export function getEncodedURI(uri) {
	const decoded = decodeURI(uri);
	return decoded == uri? encodeURI(uri): uri;

}
